export default __webpack_public_path__ + "static/media/danger-action.854a1a93.svg";